/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import cx from 'classnames';

import { getStateAbbreviation, kilometersToMiles } from '../utils/location';

import styles from './CardLocation.module.scss';

interface CardLocationProps {
    parent?: string;
    distance?: string;
    city?: string;
    state?: string;
    className?: string;
}

export function CardLocation({
    parent,
    distance: distanceProp,
    city,
    state,
    className,
}: CardLocationProps) {
    const near = city && state ? `Near ${city}, ${getStateAbbreviation(state)}` : null;

    const formatter = new Intl.NumberFormat('en-US', {
        maximumFractionDigits: 0,
    });

    const distance = kilometersToMiles(distanceProp);
    const texts: string[] = [];

    if (parent) {
        texts.push(parent);
    }
    if (near) {
        texts.push(near);
    }

    if (distance !== null) {
        texts.push(`${formatter.format(distance)} miles away`);
    }

    return (
        <div className={cx(styles.location, className)}>
            <div className="text-sm">{`${texts.join(' • ')}`}</div>
        </div>
    );
}
